import { useLocation, useNavigate } from 'react-router-dom';

interface UseSearchParams {
	getSearchParam: (key: string) => string | null;
	/** CAUTION: Using this may override react router navigation e.g. Navigate, etc. */
	setSearchParam: (key: string, value: string) => void;
	/** CAUTION: Using this may override react router navigation e.g. Navigate, etc. */
	setSearchParams: (values: { key: string; value: string }[]) => void;
	/** CAUTION: Using this may override react router navigation e.g. Navigate, etc. */
	deleteSearchParam: (key: string) => void;
}

export const useSearchParams = (): UseSearchParams => {
	const location = useLocation();
	const navigate = useNavigate();

	// Helper function to GET search params
	const getSearchParam = (key: string): string | null => {
		const params = new URLSearchParams(location.search);
		return params.get(key);
	};

	// Helper function to SET search params
	const setSearchParam = (key: string, value: string) => {
		const params = new URLSearchParams(location.search);
		params.set(key, value);
		navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
	};

	const setSearchParams = (values: { key: string; value: string }[]) => {
		const params = new URLSearchParams(location.search);
		values.forEach(({ key, value }) => params.set(key, value));
		navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
	};

	const deleteSearchParam = (key: string) => {
		const params = new URLSearchParams(location.search);
		params.delete(key);
		navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
	};

	return {
		getSearchParam,
		setSearchParam,
		setSearchParams,
		deleteSearchParam,
	};
};
